<template>
  <div class="wrapper">
    <div class="img-wrapper">
      <img :src="getImgPath(startImageIdx)" alt="" class="img img--start" />

      <img
        v-for="nr of nrOfImages"
        :key="nr * ratioLoadedImages"
        :data-src="getImgPath(nr * ratioLoadedImages)"
        alt=""
        class="img swiper-lazy"
        :style="{
          visibility:
            nr * ratioLoadedImages === Number(currentFrame)
              ? 'visible'
              : 'hidden'
        }"
        @load="onImgLoad"
      />
    </div>

    <div class="slider-wrapper">
      <input
        v-model="currentFrame"
        class="range"
        type="range"
        :min="ratioLoadedImages"
        :max="nrOfImages"
        :step="ratioLoadedImages"
      />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    startImageIdx: 2,
    currentFrame: 2,
    ratioLoadedImages: 2,
    nrOfImagesLoaded: 0
  }),
  computed: {
    getImgPath() {
      return nr => `/images/drone/dron_${nr.toString().padStart(3, '0')}.jpg`
    },
    nrOfImages() {
      return 304 / this.ratioLoadedImages
    },
    isMobile() {
      return window.innerWidth < 1170
    }
  },
  watch: {
    '$store.getters.startingPage'(value) {
      if (value) {
        this.scrollAnimation()
      }
    }
  },
  methods: {
    onImgLoad() {
      if (this.isMobile) return
      this.nrOfImagesLoaded++

      const roundedProgress = Math.round(
        (this.nrOfImagesLoaded / this.nrOfImages) * 100
      )

      if (roundedProgress !== this.progress) {
        this.$store.commit('setLoadedProgress', roundedProgress)
        this.progress = roundedProgress
      }
    },
    scrollAnimation() {
      setTimeout(() => {
        const framesAnimation = () => {
          if (this.currentFrame < this.nrOfImages) {
            this.currentFrame += this.ratioLoadedImages
            window.requestAnimationFrame(framesAnimation)
          }
        }
        window.requestAnimationFrame(framesAnimation)
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/input-range';

.wrapper {
  @include fill-space;
}

.img-wrapper {
  @include fill-space;

  background-color: $background-color;
}

.img {
  @include fill-space($position: fixed);
  object-fit: cover;
}

.slider-wrapper {
  position: relative;
  z-index: z(slider-wrapper);
}
</style>
